import Orgschema from '../components/Orgschema/Orgschema'
import Logo from '../components/Logo/Logo'
import MyPost from '../components/MyPost/MyPost'
import Types from '../components/Types/Types'
import Anketa from '../components/Anketa/Anketa'
import AnketaTemplate from '../components/Anketa/AnketaTemplate'
import Statuses from '../components/Anketa/Statuses'
import Roles from '../components/Roles/Roles'
import SystemRoles from '../components/Roles/SystemRoles'

const routes = [
  {
    path: '',
    name: 'org.hierarchy',
    component: Orgschema
  },
  {
    path: 'my-post',
    name: 'org.my-post',
    component: MyPost
  },
  {
    path: 'logo',
    name: 'org.logo',
    component: Logo
  },
  {
    path: 'types',
    name: 'org.types',
    component: Types
  },
  {
    path: 'anketa',
    name: 'org.anketa',
    component: Anketa
  },
  {
    path: 'anketa-template',
    name: 'org.anketa-template',
    component: AnketaTemplate
  },
  {
    path: 'statuses',
    name: 'org.anketa-statuses',
    component: Statuses
  },
  {
    path: 'roles',
    name: 'org.roles',
    component: Roles
  },
  {
    path: 'systemRoles',
    name: 'org.system-roles',
    component: SystemRoles
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/apps/org/router/routes.js